import React from "react";
import MainFooter from "components/AppFooter/mainFooter";
const AppFooter:React.FC<{}> = ():JSX.Element=>{
    return (
        <div>
            <MainFooter />
        </div>
    )
}
export default AppFooter;